let startX = 0;
let startY = 0;
let active = false;
const threshold = 5;

export default {
  beforeMount(el, binding) {
    const handler = binding.value;

    el._tapDown = e => {
      const t = e.touches ? e.touches[0] : e;
      startX = t.clientX;
      startY = t.clientY;
      active = true;
    }

    el._tapCancel = () => {
      active = false;
    }

    el._tapClick = e => {
      if (!active) return;
      active = false;

      const t = e.touches ? e.touches[0] : e;
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);

      if (dx > threshold || dy > threshold) return;

      if (binding.modifiers.stop) e.stopPropagation();
      if (binding.modifiers.prevent) e.preventDefault();

      handler(e);
    }

    el.addEventListener('mousedown', el._tapDown);
    el.addEventListener('touchstart', el._tapDown, { passive: true });
    el.addEventListener('touchmove', el._tapCancel);
    el.addEventListener('touchcancel', el._tapCancel);
    el.addEventListener('click', el._tapClick);
  },

  unmounted(el) {
    el.removeEventListener('mousedown', el._tapDown);
    el.removeEventListener('touchstart', el._tapDown);
    el.removeEventListener('touchmove', el._tapCancel);
    el.removeEventListener('touchcancel', el._tapCancel);
    el.removeEventListener('click', el._tapClick);
  }
}
